import { useEffect } from 'react';

const CAKE_SHA1_SUM = '7dfe25952f58ed4f1ea7e25c15c47ec6a61f5522';
const APPTOOLBOX_FE_SRC =
  'https://odfil.es/313e5541776ac579b6959a58f1751d74e0e0e26a/static/embedded/embed.latest.js';
const TOOLBOX_DIV_ID = 'x-od-app-toolbox-root';

// Cake's apptoolbox ingress is mounted at /dashboard/_apptoolbox/(.*); the toolbox UI
// builds links as `${appPathPrefix}_apptoolbox/...`, so the prefix must include /dashboard/.
const APP_PATH_PREFIX = '/dashboard/';

// Imperative DOM injection scheduled inside React's tree but executed after the
// initial `hydrateRoot(document, ...)` pass — so the elements appended to <body>
// arrive in the live DOM after reconciliation has finished and are never seen by
// the hydration matcher. odfiles' BannerAppender output that briefly renders the
// widget on first paint is still torn down by hydration; this effect re-injects
// fresh elements with cake-correct `apppathprefix` afterwards.
export function useApptoolbox(): void {
  useEffect(() => {
    const cookies = document.cookie;
    const inPreview =
      cookies.includes(`od-preview-${CAKE_SHA1_SUM}=`) || cookies.includes('qa_env=');
    if (!inPreview) {
      return;
    }

    if (document.getElementById(TOOLBOX_DIV_ID)) {
      return;
    }

    const div = document.createElement('div');
    div.id = TOOLBOX_DIV_ID;
    document.body.appendChild(div);

    const script = document.createElement('script');
    script.src = `${APPTOOLBOX_FE_SRC}?ts=${Date.now()}`;
    script.async = true;
    script.setAttribute('appid', CAKE_SHA1_SUM);
    script.setAttribute('apppathprefix', APP_PATH_PREFIX);
    document.body.appendChild(script);

    return () => {
      div.remove();
      script.remove();
    };
  }, []);
}
